<template lang="pug">
  .card.height-100
    .card-body
      .columns
        .column
          .d-flex
            user-avatar.avatar-sm(:user="filiationRequest.requester")
            .text-bold.text-ellipsis.ml-1 {{ filiationRequest.requester.fullName }}
          .text-ellipsis
            | Status:
            span.text-bold(:class="status.class")  {{ status.label }}
    .card-footer
      .columns.align-center
        .column
          .text-small Adicionado em #[span.text-bold {{ filiationRequest.createdAt | toDate('DD/MM/YYYY') }}]
        .column.col-auto
          router-link.btn.btn-action.btn-sm.btn-link.tooltip(
            :to="{ name: 'filiations.requests.review', params: { id: filiationRequest.id } }"
            :data-tooltip="filiationRequest.status === 'waiting' ? 'Revisar' : 'Exibir'"
          )
            i.fas(:class="filiationRequest.status === 'waiting' ? 'fa-clipboard-check' : 'fa-eye'")
</template>

<script>
import { filiationRequestStatusClasses } from '@/lib/constants'

export default {
  computed: {
    status() {
      return filiationRequestStatusClasses[this.filiationRequest.status] || {}
    },
  },
  props: {
    filiationRequest: { type: Object, required: true },
  },
}
</script>
